export default __webpack_public_path__ + "static/media/php.5af53aef.svg";